import { crudMdActions } from "@/services/crud-md-actions";

const name = "organization-companies";

export default {
  name,
  ...crudMdActions(name),
};
